import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import ImageWithBasePath from "../../img/imagewithbasebath";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  GET_PROD,
  INSERT_SUPPLIER,
  GET_SUPPLIER_DETAILS,
} from "../../../Config";
import Axios from "axios";
import Select from "react-select";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const SupplierModal = ({ supplierObj }) => {

  useEffect(() => {
    console.log(supplierObj, 'supplierObjsupplierObjsupplierObj');
  }, [supplierObj]);

  const [userDataSession, setUserDataSession] = useState([]);
  const [supplierDetails, setSupplierDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // #region Session for userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && supplierObj.Id) {
      setLoading(true);
      const url = `${API_BASE_URL}${GET_SUPPLIER_DETAILS}?OrgId=${userDataSession.OrgId}&SupplierId=${supplierObj.Id}`;
      Axios.get(url)
        .then((response) => {
          // console.log(response.data.ResultData[0], "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
          if (response.data) {
            setSupplierDetails(response.data.ResultData[0]);
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession, supplierObj.Id]);

  const [editSubmitBtnLoading, setEditSubmitBtnLoading] = useState(false);
  const [addSubmitBtnLoading, setAddSubmitBtnLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [addAddressType, setAddAddressType] = useState("Office");
  const [addAccountType, setAddAccountType] = useState("Savings");
  const [editAddressType, setEditAddressType] = useState(null);
  const [editAccountType, setEditAccountType] = useState(null);

  const [editFormData, setEditFormData] = useState({
    Supplier: {
      SupplierName: "",
      EmailId: "",
      PhoneNo: "",
      ContactName: "",
      AlternatePhoneNo: "",
      RegistrationNo: "",
      PayTermDays: "",
      GSTIN: "",
      Website: "",
      Notes: "",
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      State: "",
      ZIPCode: "",
    },
    bank: [
      {
        Id: "",
        BankName: "",
        AccountNumber: "",
        IFSCCode: "",
        AccountType: "",
      },
    ],
  });

  useEffect(() => {
    if (supplierDetails) {
      setEditFormData({
        orgid: userDataSession.OrgId,
        userid: userDataSession.UserId,
        Supplier: {
          Id: supplierDetails.Id,
          SupplierName: supplierDetails.SupplierName || "",
          RegistrationNo: supplierDetails.RegistrationNo || "",
          GSTIN: supplierDetails.GSTIN || "",
          Status: "Pending",
          PayTermDays: supplierDetails.PayTermDays || "",
          ContactName: supplierDetails.ContactName || "",
          EmailId: supplierDetails.EmailId || "",
          PhoneNo: supplierDetails.PhoneNo || "",
          AlternatePhoneNo: supplierDetails.AlternatePhoneNo || "0",
          Website: supplierDetails.Website || "",
          AddressType: supplierDetails.AddressType || "Office",
          AddressLine1: supplierDetails.AddressLine1 || "",
          AddressLine2: supplierDetails.AddressLine2 || "",
          City: supplierDetails.City || "",
          State: supplierDetails.State || "",
          Country: "India",
          ZIPCode: supplierDetails.ZIPCode || "",
          Notes: supplierDetails.Notes || "",
          IsIGST: 1,
          IsVendor: 0,
          IsActive: 1,
          CreatedBy: userDataSession.UserId,
        },
        bank: [
          {
            Id: supplierDetails.BankId,
            BankName: supplierDetails.BankName || "",
            AccountNumber: supplierDetails.AccountNumber || "",
            IFSCCode: supplierDetails.IFSCCode || "",
            AccountType: supplierDetails.AccountType || "",
            IsActive: 1,
          },
        ],
      });
    }
  }, [supplierDetails, userDataSession]);

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    const [nameParts, key] = name.split(".");

    if (nameParts && key) {
      if (nameParts === "bank") {
        setEditFormData((prevState) => ({
          ...prevState,
          [nameParts]: [
            {
              ...prevState[nameParts][0],
              [key]: value,
            },
          ],
        }));
      } else {
        setEditFormData((prevState) => ({
          ...prevState,
          [nameParts]: {
            ...prevState[nameParts],
            [key]: value,
          },
        }));
      }
    } else {
      setEditFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // #region Edit supplier func
  const handleEditSubmit = (e) => {
    e.preventDefault();
    setEditSubmitBtnLoading(true);
    console.log(selectedProduct);
    console.log(editFormData, "sending edit data top api");

    Axios.post(`${API_BASE_URL}${INSERT_SUPPLIER}`, editFormData)
      .then((response) => {
        console.log(response.data, "resposnse data...");
        if (response) {
          setAddSubmitBtnLoading(false);

          // Show success message
          Swal.fire({
            title: `Supplier updated Successfully.`,
            icon: "success",
          }).then((result) => {
            // Reload the page after the user acknowledges the success message
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
              fetchAndUpdateSessionData();
            }
          });
        } else {
          setAddSubmitBtnLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setEditSubmitBtnLoading(false);
        console.error("Error updating supplier:", error);
      });
  };

  const [addFormData, setAddFormData] = useState({
    orgid: userDataSession.OrgId,
    userid: userDataSession.UserId,
    Supplier: {
      SupplierName: "",
      RegistrationNo: "",
      GSTIN: "",
      Status: "Approved",
      PayTermDays: "",
      ContactName: "",
      EmailId: "",
      PhoneNo: "",
      AlternatePhoneNo: "",
      Website: "",
      AddressType: "",
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      State: "",
      Country: "India",
      ZIPCode: "",
      Notes: "",
      IsIGST: 1,
      IsVendor: 0,
      IsActive: 1,
      CreatedBy: userDataSession.UserId,
    },
    bank: [
      {
        Id: 0,
        BankName: "",
        AccountNumber: "",
        IFSCCode: "",
        AccountType: "",
        IsActive: 1,
      },
    ],
  });

  const handleAddAddressSelectChange = (event) => {
    setAddAddressType(event.target.value);
  };

  const handleAddAccountSelectChange = (event) => {
    setAddAccountType(event.target.value);
  };

  const handleEditAddressSelectChange = (event) => {
    setEditAddressType(event.target.value);
  };

  const handleEditAccountSelectChange = (event) => {
    setEditAccountType(event.target.value);
  };

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    const [objectName, key] = name.split(".");

    if (objectName && key) {
      if (objectName === "bank") {
        setAddFormData((prevState) => ({
          ...prevState,
          [objectName]: [
            {
              ...prevState[objectName][0],
              [key]: value,
            },
          ],
        }));
      } else {
        setAddFormData((prevState) => ({
          ...prevState,
          [objectName]: {
            ...prevState[objectName],
            [key]: value,
          },
        }));
      }
    } else {
      setAddFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const fetchAndUpdateSessionData = () => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(`${API_BASE_URL}Admin/getDDl?&LoggedInUser=${userDataSession.UserId}&OrgId=${userDataSession.OrgId}`)
        .then(response => {
          if (response.data) {
            const allData = response.data.ResultData;
  
            // Define the DDL names to filter
            const ddlNames = ['Supplier', 'CATEGORY', 'Subcategories', 'Products', 'variantypes', 'TAX', 'Stores', 'BRAND', 'UNITS'];
  
            // Iterate through each DDL name, filter data, and save to session storage
            ddlNames.forEach(name => {
              const filteredData = allData.filter(item => item.DDLName === name);
              sessionStorage.setItem(`filteredDDLData_${name}`, JSON.stringify(filteredData));
            });
  
            console.log('Filtered data saved successfully');
          } else {
            console.error('Error fetching data:', response.data);
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  };

  // #region Add supplier func
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setAddSubmitBtnLoading(true);
  
    // Prepare form data
    addFormData.orgid = userDataSession.OrgId;
    addFormData.Supplier.Id = 0;
    // addFormData.Supplier.EmailId = 'NULL';
    addFormData.userid = userDataSession.UserId;
    addFormData.Supplier.CreatedBy = userDataSession.UserId;
    addFormData.Supplier.AddressType = addAddressType;
    addFormData.bank.AccountType = addAccountType;
  
    const formattedData = {
      orgid: addFormData.orgid,
      userid: addFormData.userid,
      Supplier: {
        ...addFormData.Supplier,
        Id: 0,
      },
      bank: addFormData.bank,
    };
  
    console.log(formattedData, "sending data to add API.");
  
    try {
      const response = await Axios.post(
        `${API_BASE_URL}${INSERT_SUPPLIER}`,
        formattedData
      );
      
      console.log(response.data, "response data...", response.data.error);
      
      if (response.data.error) {
        setAddSubmitBtnLoading(false);
  
        Swal.fire({
          title: response.data.error,
          icon: "error",
        })
      } else{
        setAddSubmitBtnLoading(false);
        fetchAndUpdateSessionData();
        Swal.fire({
          title: "Success",
          text: "Supplier added Successfully..!",
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      }
    } catch (error) {
      setAddSubmitBtnLoading(false);
      console.error("Error:", error);
  
      Swal.fire({
        title: "Error",
        text: error.response?.data?.error || "Something went wrong! Please try again.",
        icon: "error",
      });
    }
  };  

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        Id: 0,
        CategoryId: 0,
        BarCode: 0,
      };

      Axios.post(`${API_BASE_URL}${GET_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const handleProductChange = (selectedOption) => {
    setSelectedProduct(selectedOption);
  };

  return (
    <div>
      {/* Add Supplier */}
      {addSubmitBtnLoading&&(<SpinLoader/>)}
      <div className="modal fade" id="add-units">
        <div
          className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
          style={{ maxWidth: "70%" }}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body custom-modal-body"
                  style={{ height: "520px" }}
                >
                  <ul
                    className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                    id="myTab1"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="order-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#order-tab-pane-add"
                        type="button"
                        role="tab"
                        aria-controls="order-tab-pane-add"
                        aria-selected="true"
                      >
                        <i className="fa-regular fa-address-book me-1 align-middle"></i>
                        Personal Info
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="confirmed-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#confirm-tab-pane-add"
                        type="button"
                        role="tab"
                        aria-controls="confirm-tab-pane-add"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-building-columns me-1 align-middle"></i>
                        Bank Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="shipped-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#shipped-tab-pane-add"
                        type="button"
                        role="tab"
                        aria-controls="shipped-tab-pane-add"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-house-user me-1 align-middle"></i>
                        Address
                      </button>
                    </li>
                  </ul>
                  <form onSubmit={handleAddSubmit}>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active text-muted"
                        id="order-tab-pane-add"
                        role="tabpanel"
                        aria-labelledby="order-tab"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Supplier Name<span className="fw-bold text-danger">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.SupplierName"
                                value={addFormData.Supplier.SupplierName || ""}
                                onChange={handleAddInputChange}
                                placeholder="Organization name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Email
                                {/* <span className="fw-bold text-danger">*</span> */}
                                </label>
                              <input
                                type="email"
                                className="form-control"
                                name="Supplier.EmailId"
                                value={addFormData.Supplier.EmailId || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter email"
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Phone<span className="fw-bold text-danger">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.PhoneNo"
                                value={addFormData.Supplier.PhoneNo || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter phone no"
                                maxLength={10}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Contact Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.ContactName"
                                value={addFormData.Supplier.ContactName || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter contact name"
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Alternate Phone No</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.AlternatePhoneNo"
                                value={
                                  addFormData.Supplier.AlternatePhoneNo || ""
                                }
                                onChange={handleAddInputChange}
                                maxLength={10}
                                placeholder="Enter alternate no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Reg No</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.RegistrationNo"
                                value={
                                  addFormData.Supplier.RegistrationNo || ""
                                }
                                onChange={handleAddInputChange}
                                placeholder="Enter registration no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Payterm</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.PayTermDays"
                                value={addFormData.Supplier.PayTermDays || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter payterm"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>GSTIN</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.GSTIN"
                                value={addFormData.Supplier.GSTIN || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter GST no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Website</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.Website"
                                value={addFormData.Supplier.Website || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter GST no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="input-blocks">
                              <label>Description</label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="Supplier.Notes"
                                value={addFormData.Supplier.Notes || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter notes..."
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade text-muted"
                        id="confirm-tab-pane-add"
                        role="tabpanel"
                        aria-labelledby="confirmed-tab"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.BankName"
                                value={addFormData.bank[0].BankName || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter bank name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Account No</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.AccountNumber"
                                value={addFormData.bank[0].AccountNumber || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter account number"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>IFSC Code</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.IFSCCode"
                                value={addFormData.bank[0].IFSCCode || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter IFSC code"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Account Type</label>
                              <select
                                className="form-select"
                                name="AddAccountType"
                                value={addAccountType}
                                onChange={handleAddAccountSelectChange}
                              >
                                <option disabled>Choose type</option>
                                <option value="Savings">Savings</option>
                                <option value="Current">Current</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade text-muted"
                        id="shipped-tab-pane-add"
                        role="tabpanel"
                        aria-labelledby="shipped-tab"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Country</label>
                              <input
                                type="text"
                                className="form-control"
                                value="India"
                                style={{ cursor: "not-allowed" }}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>City</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.City"
                                value={addFormData.Supplier.City || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter city"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>State</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.State"
                                value={addFormData.Supplier.State || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter state"
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>ZipCode</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.ZIPCode"
                                value={addFormData.Supplier.ZIPCode || ""}
                                onChange={handleAddInputChange}
                                placeholder="Enter pipncode"
                                // required
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Address Type</label>
                              <select
                                className="form-select"
                                name="AddressType"
                                value={addAddressType}
                                onChange={handleAddAddressSelectChange}
                              >
                                <option disabled>Choose type</option>
                                <option value="Office">Office</option>
                                <option value="Warehouse">Warehouse</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-0 input-blocks">
                              <label className="form-label">Address</label>
                              <textarea
                                className="form-control mb-1"
                                placeholder="Enter full address"
                                name="Supplier.AddressLine1"
                                value={addFormData.Supplier.AddressLine1 || ""}
                                onChange={handleAddInputChange}
                              />
                              <p>Maximum 600 Characters</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        disabled={addSubmitBtnLoading}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-submit" disabled={addSubmitBtnLoading}>
                        {addSubmitBtnLoading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Supplier */}

      {/* Edit Supplier */}
      <div className="modal fade" id="edit-suppliers">
        <div
          className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
          style={{ maxWidth: "70%" }}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body custom-modal-body"
                  style={{ height: "530px" }}
                >
                  <ul
                    className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                    id="myTab1"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="order-tab-edit"
                        data-bs-toggle="tab"
                        data-bs-target="#order-tab-pane-edit"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                      >
                        <i className="fa-regular fa-address-book me-1 align-middle"></i>
                        Personal Info
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="confirmed-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#confirm-tab-pane-edit"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-building-columns me-1 align-middle"></i>
                        Bank Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="shipped-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#shipped-tab-pane-edit"
                        type="button"
                        role="tab"
                        aria-controls="contact-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-house-user me-1 align-middle"></i>
                        Address
                      </button>
                    </li>
                  </ul>
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <form onSubmit={handleEditSubmit}>
                      <div className="tab-content" id="myTabContentEdit">
                        <div
                          className="tab-pane show active fade text-muted "
                          id="order-tab-pane-edit"
                          role="tabpanel"
                          aria-labelledby="home-tab-1"
                          tabIndex={0}
                        >
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Supplier Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.SupplierName"
                                  value={
                                    (editFormData &&
                                      editFormData.Supplier.SupplierName) ||
                                    ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Organization name"
                                />
                                {supplierDetails.SupplierName}
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Email</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  name="Supplier.EmailId"
                                  value={editFormData.Supplier.EmailId || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter email"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Phone</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.PhoneNo"
                                  value={editFormData.Supplier.PhoneNo || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter phone no"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Contact Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.ContactName"
                                  value={
                                    editFormData.Supplier.ContactName || ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Enter contact name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Alternate Phone No</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Supplier.AlternatePhoneNo"
                                  value={
                                    editFormData.Supplier.AlternatePhoneNo || ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Enter alternate no"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Reg No</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.RegistrationNo"
                                  value={
                                    editFormData.Supplier.RegistrationNo || ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Enter registration no"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Payterm</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Supplier.PayTermDays"
                                  value={
                                    editFormData.Supplier.PayTermDays || ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Enter payterm"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>GSTIN</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.GSTIN"
                                  value={editFormData.Supplier.GSTIN || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter GST no"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Website</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.Website"
                                  value={editFormData.Supplier.Website || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter GST no"
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="input-blocks">
                                <label>Description</label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="Supplier.Notes"
                                  value={editFormData.Supplier.Notes || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter notes..."
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade text-muted"
                          id="confirm-tab-pane-edit"
                          role="tabpanel"
                          aria-labelledby="profile-tab-2"
                          tabIndex={0}
                        >
                          <div className="row">
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="bank.BankName"
                                  value={editFormData.bank[0].BankName || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter bank name"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>Account No</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="bank.AccountNumber"
                                  value={
                                    editFormData.bank[0].AccountNumber || ""
                                  }
                                  onChange={handleEditInputChange}
                                  placeholder="Enter account number"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>IFSC Code</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="bank.IFSCCode"
                                  value={editFormData.bank[0].IFSCCode || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter IFSC code"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>Account Type</label>
                                <select
                                  className="form-select"
                                  name="AddAccountType"
                                  value={editAccountType}
                                  onChange={handleEditAccountSelectChange}
                                >
                                  <option value="Savings">Savings</option>
                                  <option value="Current">Current</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade text-muted"
                          id="shipped-tab-pane-edit"
                          role="tabpanel"
                          aria-labelledby="contact-tab-edit"
                          tabIndex={0}
                        >
                          <div className="row">
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>Country</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value="India"
                                  style={{ cursor: "not-allowed" }}
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>City</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.City"
                                  value={editFormData.Supplier.City || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter city"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-10 col-10">
                              <div className="input-blocks">
                                <label>State</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="Supplier.State"
                                  value={editFormData.Supplier.State || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter state"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>ZipCode</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="Supplier.ZIPCode"
                                  value={editFormData.Supplier.ZIPCode || ""}
                                  onChange={handleEditInputChange}
                                  placeholder="Enter pipncode"
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Address Type</label>
                                <select
                                  className="form-select"
                                  name="AddressType"
                                  value={editAddressType}
                                  onChange={handleEditAddressSelectChange}
                                >
                                  <option value="Office">Office</option>
                                  <option value="Warehouse">Warehouse</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-0 input-blocks">
                                <label className="form-label">Address</label>
                                <textarea
                                  className="form-control mb-1"
                                  placeholder="Enter full address"
                                  name="Supplier.AddressLine1"
                                  value={
                                    editFormData.Supplier.AddressLine1 || ""
                                  }
                                  onChange={handleEditInputChange}
                                />
                                <p>Maximum 600 Characters</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                          disabled={editSubmitBtnLoading}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-submit" disabled={editSubmitBtnLoading}>
                          {editSubmitBtnLoading ? "Submitting..." : "Submit"}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Supplier */}

      <div className="modal fade" id="map-suppliers">
        <div className="modal-dialog modal-dialog-centered custom-modal-two mt-5">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Supplier Items</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form>
                    <div className="row">
                      <div className="col-lg-12">
                        <h3 className="text-center">
                          {supplierObj.SuplierName || ""}
                        </h3>
                      </div>
                    </div>
                    <div className="my-3">
                      <label>Products</label>
                      <Select
                        mode="multiple"
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Choose products"
                        onChange={handleProductChange}
                        options={productsData.map((product) => ({
                          value: product.Id,
                          label: product.ProductName,
                        }))}
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-submit">
                        {/* {editSubmitBtnLoading ? 'Submitting..' : 'Submit'} */}
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SupplierModal.propTypes = {
  supplierObj: PropTypes.object.isRequired,
};

export default SupplierModal;
